/* eslint-disable prettier/prettier */
import {
  InsertarCita,
  NotificarPaciente,
  NotificarMedico,
  GetDocumentosCita,
  GetAllCitas,
  GetAllCitasSolicitud,
  GetCitasProximas,
  GetCitasAnteriores,
  CargarDocumentoCita,
  DeleteCita,
} from "../apis";
import axios from "axios";
import toast from "react-hot-toast";
import { store } from "../store";

import {
  setCitas,
  isLoadingCitas,
  setCitasProximas,
  isLoadingCitasProximas,
  setCitasAnteriores,
  isLoadingCitasAnteriores,
  setCitaAdd,
  setCitaProxAdd,
  setDocs,
  setDocsAnt,
  isLoadingDocs,
  removeCita,
  removeCitaProx,
} from "./tavSlice";

// Action creators are generated for each case reducer function
export function InformacionAllCitas(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoadingCitas());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  var data = {
    idSolicitud: 0,
  };

  axios
    .post(GetAllCitas(), data, header)
    .then((response) => {
      dispatch(setCitas(response.data.data));
    })
    .catch((error) => {});
}

export function InformacionCitas(dispatch, idSolicitud) {
  const token = store.getState().login.token;
  dispatch(isLoadingCitas());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  var data = {
    idSolicitud: idSolicitud,
  };

  axios
    .post(GetAllCitasSolicitud(), data, header)
    .then((response) => {
      dispatch(setCitas(response.data.data));
    })
    .catch((error) => {});
}

export const InformacionCitasExcel = async (id) => {
  const token = store.getState().login.token;
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };
    var data = {
      idSolicitud: id,
    };
    const response = await axios.post(GetAllCitasSolicitud(), data, header);
    if (response.data.code === "Ok") {
      return response.data.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export function InformacionCitasProximas(dispatch, idEstudio, idSolicitud) {
  const token = store.getState().login.token;
  dispatch(isLoadingCitasProximas());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(
      GetCitasProximas().concat("?idEstudio=" + idEstudio + "&" + "idSolicitud=" + idSolicitud),
      header
    )
    .then((response) => {
      dispatch(setCitasProximas(response.data.data));
    })
    .catch((error) => {});
}

export function InformacionCitasAnteriores(dispatch, idEstudio, idSolicitud) {
  const token = store.getState().login.token;
  dispatch(isLoadingCitasAnteriores());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(
      GetCitasAnteriores().concat("?idEstudio=" + idEstudio + "&" + "idSolicitud=" + idSolicitud),
      header
    )
    .then((response) => {
      dispatch(setCitasAnteriores(response.data.data));
    })
    .catch((error) => {});
}

export function AgregarCita(dispatch, dataCita, tav) {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando, por favor espere...");

  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  var data = {
    ...dataCita,
    idUsuario: usuario.idUsuario,
  };

  axios
    .post(InsertarCita(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al agregar la cita");
      }
      if (response.data.code === "Ok") {
        toast.success("Éxito al agregar la cita");
        if (tav) {
          dispatch(setCitaProxAdd(response.data.data));
        } else {
          dispatch(setCitaAdd(response.data.data));
        }
      }
    })
    .catch((error) => {
      toast.remove(id);
      toast.error("Error al agregar la cita");
    });
}

export const ObtenerDocumentosCita = (idCita, tav) => async (dispatch) => {
  const token = store.getState().login.token;
  if (tav) {
    dispatch(
      setDocsAnt({
        idCita: idCita,
        data: null,
        estatus: true,
      })
    );
  } else {
    dispatch(
      setDocs({
        idCita: idCita,
        data: null,
        estatus: true,
      })
    );
  }

  dispatch(isLoadingDocs());
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  const data = {
    idCita: idCita,
  };
  axios
    .post(GetDocumentosCita(), data, header)
    .then((response) => {
      if (response.data.code === "Error") {
      }
      if (response.data.code === "Ok") {
        if (tav) {
          dispatch(
            setDocsAnt({
              idCita: idCita,
              data: response.data.data,
              estatus: false,
            })
          );
        } else {
          dispatch(
            setDocs({
              idCita: idCita,
              data: response.data.data,
              estatus: false,
            })
          );
        }
      }
    })
    .catch((error) => {});
};

export function AgregarDocumentoCita(dispatch, data, tav) {
  const token = store.getState().login.token;
  let id = toast.loading("Procesando, por favor espere...");

  const header = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .post(CargarDocumentoCita(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al cargar el documento");
      }
      if (response.data.code === "Ok") {
        if (tav) {
          dispatch(ObtenerDocumentosCita(data.IdCita, true));
        } else {
          dispatch(ObtenerDocumentosCita(data.IdCita, false));
        }
        toast.success("Éxito al cargar el documento");
      }
    })
    .catch((error) => {
      toast.remove(id);
    });
}

export function NotificarPacienteCita(idSolicitud) {
  let id = toast.loading("Procesando, por favor espere...");
  const token = store.getState().login.token;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  const data = {
    idSolicitud: idSolicitud,
  };
  axios
    .post(NotificarPaciente(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al notificar al paciente");
      }
      if (response.data.code === "Ok") {
        toast.success("Paciente notificado con éxito");
      }
    })
    .catch((error) => {
      toast.error("Error al notificar al paciente");
      toast.remove(id);
    });
}

export function NotificarMedicoCita(dataSolicitud) {
  let id = toast.loading("Procesando, por favor espere...");
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  const data = {
    ...dataSolicitud,
    idUsuario: usuario.idUsuario,
  };
  axios
    .post(NotificarMedico(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al notificar al médico");
      }
      if (response.data.code === "Ok") {
        toast.success("Médico notificado con éxito");
      }
    })
    .catch((error) => {
      toast.error("Error al notificar al médico");
      toast.remove(id);
    });
}

export const EliminarCita = (dataCita, tav) => async (dispatch) => {
  let id = toast.loading("Procesando, por favor espere...");
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;

  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };

    const dataEnviar = {
      ...dataCita,
      usuario: usuario.username,
    };
    const response = await axios.post(DeleteCita(), dataEnviar, header);
    toast.remove(id);
    if (response.data.code === "Error") {
      toast.error("Error al eliminar la cita");
      return false;
    }
    if (response.data.code === "Ok") {
      if (tav) {
        dispatch(removeCitaProx(dataCita.idCita));
      } else {
        dispatch(removeCita(dataCita.idCita));
      }
      toast.success("Éxito al eliminar la cita");
      return true;
    }
  } catch (error) {
    toast.error("Error al eliminar la cita");
    toast.remove(id);

    return false;
  }
};
